import React from 'react';

import { FlexRow } from 'ui-components/components/flex';
import { Gap } from 'ui-components/components/flex/gap';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { SingleLabelPromotionalSection } from './components/single-label-promotional-section';
import style from './single-label-calculator.module.less';
import { CalculatorSection } from '../shipping-rate-calculator/components/calculator-section';
import { useShippingCalculator } from '../shipping-rate-calculator/hooks/use-shipping-calculator';

export const SingleLabelShippingRateCalculator = () => {
  const calculatorProps = useShippingCalculator('SINGLE_LABEL_HOME_PAGE_CALCULATOR');

  return (
    <FlexRow className={style['single-label-shipping-calculator']}>
      <CalculatorSection
        {...calculatorProps}
        buttonTheme={THEME_CONSTANTS.primary}
        className={style['calculator-section']}
        gap={Gap.Space8}
        stylesheet={style}
        weightContainerClassName={style['weight-number-input']}
        weightInputClassName={style['weight-input']}
      />
      <SingleLabelPromotionalSection />
    </FlexRow>
  );
};
